import useSWR from 'swr';
import { RequestParams } from 'integration/generated/transactions/http-client';
import { transactionsDepartment } from 'integration/transactions';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';

type FindDepartmentQuery = {
	catentries?: string;
};

export const findDepartmentFetcher =
	(pub: boolean) => async (storeId: string, query: FindDepartmentQuery, params: RequestParams) => {
		const response = await transactionsDepartment(pub).findDepartment(storeId, query, params);
		return response;
	};

const DATA_KEY_FIND_DEPARTMENT = 'findDepartment';

export const useFindDepartment = (args?: FindDepartmentQuery) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { storeId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();

	const rawSwr = useSWR(
		storeId && args?.catentries ? [{ storeId, ...args }, DATA_KEY_FIND_DEPARTMENT] : null,
		async ([{ storeId, ...query }]) => findDepartmentFetcher(true)(storeId, query, params)
	);

	return rawSwr;
};
